import { render, staticRenderFns } from "./Audit.vue?vue&type=template&id=1a96a9d2&"
import script from "./Audit.vue?vue&type=script&lang=ts&"
export * from "./Audit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports